export const ACTION_PREFIX = 'STARTUP_CONFIG';
export const PARTITION = 'startupConfig';

export const actionTypes = {
  GET_STARTUP_CONFIG_PENDING: 'GET_STARTUP_CONFIG_PENDING',
  GET_STARTUP_CONFIG_FULFILLED: 'GET_STARTUP_CONFIG_FULFILLED',
  GET_STARTUP_CONFIG_REJECTED: 'GET_STARTUP_CONFIG_REJECTED',
};
